import React from 'react'
import Section from '../../components/shared/Section';
import BannerSection from '../../components/shared/BannerSection';
import Tagline from '../../components/shared/Tagline';
import FollowSection from './aboutComponents/FollowSection';
import StillSection from '../../components/shared/StillSection';
import GallerySection from './aboutComponents/GallerySection';
import BookingSection from '../../components/shared/BookingSection';

const About = () => {
    return (
        <>
            <BannerSection />
            <Tagline />
            <Section
                heading='What do we do'
                imageUrl='/images/section/sectionImg3.png'
                description="
                At our wellness center, we are dedicated to transforming lives through a holistic approach to health and fitness. Our services include personalized fitness training, nutritional counseling, and comprehensive wellness programs designed to meet your unique needs.
                We believe in empowering our clients with the knowledge and tools they need to achieve and maintain their health goals.
                Whether you're looking to lose weight, build muscle, improve your diet, or simply enhance your overall well-being, we provide expert guidance and support every step of the way. Join us on a journey to a healthier, happier you.
                "
                />
            <Section
                reverse
                imageUrl='/images/section/sectionImg2.png'
                heading='What is Health Architect'
                description="
                A Health Architect is a specialist who designs personalized wellness plans that encompass fitness, nutrition, and lifestyle changes to help you achieve optimal health.
                By taking a holistic approach, a Health Architect integrates various elements of well-being to create a balanced and sustainable path tailored to your unique needs.
                This role involves guiding you through each step of your health journey with expert advice and personalized strategies, ensuring that you build a strong foundation for long-term wellness and a vibrant, healthy life.    
                "
                />
            <Section
                heading='About me'
                imageUrl='/images/section/sectionImg1.png'
                description="
                    Hello, I'm Dr. Monty, a dedicated fitness expert and nutritionist with over a decade of experience in helping individuals achieve their health and wellness goals. My passion lies in creating personalized fitness plans and nutritional guidance that empower my clients to live healthier, more balanced lives. Whether you're looking to lose weight, build muscle, or improve your overall well-being, I'm here to support you every step of the way. Join me on this journey to a fitter, healthier you!.
                "
            />
            <BookingSection/>

            <FollowSection />
            <GallerySection />
            <StillSection />
        </>
    )
}

export default About;